/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/common/date-time/date-time')
require('components/common/drop-menu-input/drop-menu-input')
require('components/base/tab/tab')
require('components/base/icon/icon')
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');

const store = require('appVuex/store');
const confirm = require('components/base/pop/confirm');
const tip = require('components/base/pop/tip');
const configPushMixin = require('../../mixin')
const ajaxHttp = require('appUtil/ajaxHttp.js')
const { apiPath } = require('appService/api');

require('./list-topic-list.scss');
const template = require('./list-topic-list.tpl');

const listTopicList = {
  name: "list-topic-list",

  template,

  mixins: [configPushMixin],

  data() {
    return {
      thItems: ["序号", "图片", "推荐话题", "推荐时间", "投放范围", "投放品牌", "状态", "操作"],
      url: apiPath.configPush.listTopic.list
    }
  },

  computed: {
    brandDropMenu() {
      return [{
        brandId: -1,
        vertifyBrand: '请选择'
      }].concat(this.brandList)
    }
  },

  store,

  filters: {
    listTopicStatus(val) {
      switch (val) {
        case 0: return '未到期';
        case 1: return '已过期';
        case 2: return '已下架';
        case 3: return '生效中';
        default: return '--'
      }
    }
  },

  methods: {
    offlineDisplay(status) {
      return !(status === 2)
    },

    editDisplay(status) {
      return !(status === 2)
    },

    fetchQuery({ queryValue }) {
      return this.$refs.tableData.query(queryValue).fetch()
    },

    offLine(id) {
      let self = this

      confirm({
        message: '确定下架广告？',
        cb(confirm) {
          confirm.hide()

          ajaxHttp(apiPath.configPush.listTopic.offline, {
            data: {
              id: id
            }
          }).then((rtn) => {
            self.$refs.tableData.fetch()

            tip('下架成功！')
          }).catch((rtn) => {
            tip(rtn.error)
          })
        }
      })
    }
  }
}

module.exports = listTopicList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/list-topic/list-topic-list/list-topic-list.js